module.exports = __webpack_public_path__ + "img/icon-circle-plus.b7b5a122.svg";